<template data-tipo-componente="componente-tipo-resposta-texto">

<div :class="`card ${isDebug ? 'add-border':''}`" data-tipo-componente="componente-tipo-resposta-texto">
  
 <!-- Card content -->
  <div class="card-body">

    <!-- Title -->
    <div class="row">
      <div class="col-md-11">
      <h6 class="card-title">
        <a>{{ pergunta.ordemExibicao}} ) {{ pergunta.titulo }}</a>
        <span v-if="pergunta.obrigatoria" style="color:red;font-weigth:bold">*</span>
      </h6>
      <p v-if="pergunta.subTitulo">
        <small>{{pergunta.subTitulo}}</small>
      </p>
      </div>
      <div class="col">
        <!-- <span class="badge badge-success" style="float:rigth"><i class="bi bi-check"></i></span> -->
      </div>
    </div>
    <!-- Text -->
    <p class="card-text" v-if="pergunta.descricao" v-html="pergunta.descricao"></p>
    <div>
    <!--opcoes de resposta -->
      <div class="opcoes-resposta" :key="`opcao_resposta_${opcaoResposta.opcaoRespostaId}`" v-for="(opcaoResposta) in opcoesRespostas">
        <div class="custom-control custom-radio">
            <input 
                @click="responderPergunta(pergunta,opcaoResposta,$event)" 
                type="radio"
                :value="opcaoResposta.valor"
                v-model="respostaSelecionada"                
                class="custom-control-input" 
                :id="`input_radio_${pergunta.perguntaId}_${opcaoResposta.opcaoRespostaId}`"
                :name="`input_radio_${pergunta.perguntaId}`">
            <label class="custom-control-label" :for="`input_radio_${pergunta.perguntaId}_${opcaoResposta.opcaoRespostaId}`">{{opcaoResposta.valor}}</label>
        </div>
      </div>
    </div>
   
  </div>

</div>

</template>

<script>
import repostaPerguntaMethodsMixin from './ResponderPerguntaMixin'
export default {
  mixins: [repostaPerguntaMethodsMixin],
  name: 'comp-pergunta-radiobutton',
  props: ['pergunta', 'permitirResponder'],
  data () {
    return {
      resposta: '',
      respostaSelecionada:null,
      ultimaOpcaoResposta:null
    }
  },
  computed: {
    nomeOpcaoResposta(){
      return `opcaoResposta_pergunta_${this.pergunta.perguntaId}`
    },
   
    botaoDesabilitado () {
      return this.resposta === '' || !this.permitirResponder
    },
    opcoesRespostas () {
      return this.pergunta.opcoesResposta.sort((a, b) => a.ordemExibicao - b.ordemExibicao);
    }
  },
  methods: {
    obterId(opcaoResposta){
      return `opcao_resposta_pergunta_${opcaoResposta.opcaoRespostaPerguntaId}`
    },
    responderPergunta (pergunta,opcaoResposta, event) {
      if(this.ultimaOpcaoResposta && this.ultimaOpcaoResposta == opcaoResposta.opcaoRespostaId)
        return;
      
      const {
          opcaoRespostaId,
          perguntaId, 
          perguntasEncadeadasIds, 
          tipoEncadeamentoPergunta,
          encadeamentosPerguntasIds,
          sessaoFormularioPerguntaId,
          sessaoFormularioId,
          valor
        } = opcaoResposta;

      this.removerTodasRespostasPergunta(sessaoFormularioPerguntaId);
      this.responderPerguntaMixin({pergunta, opcaoResposta});
      this.ultimaOpcaoResposta = opcaoRespostaId

      //verificar se existe pergunta encadeada a resposta      
      const configPerguntaEncadeada = 
        {
          ...pergunta,
          perguntaId,
          opcaoRespostaId,
          perguntasEncadeadasIds,
          tipoEncadeamentoPergunta,
          encadeamentosPerguntasIds, 
          valor,
          sessaoFormularioPerguntaId,
          sessaoFormularioId
       }   
      
      this.verificarPerguntaEncadeada(configPerguntaEncadeada);
    }
  },
  mounted () {
   
    const {perguntasRespondidas} = this.$store.state;
    const {perguntaId} = this.pergunta;
    if(perguntasRespondidas && perguntasRespondidas.length) {
        const [perguntaRespondida] = perguntasRespondidas.filter(p=>p.perguntaId == perguntaId);
        if(perguntaRespondida){
          const {respostas} = perguntaRespondida;
          if(respostas && respostas.length) {
            this.respostaSelecionada = respostas[0].valor;
          }
        }
    }

    if(this.isDebug){
      console.log('perguntaId', perguntaId)
      console.log('init radio button', this.pergunta.titulo)
    }
  
  }
}
</script>

<style>
  .opcoes-resposta{
    font-size: 12pt;
  }
  .add-border {
    border:2px solid orange;
  }
</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/RepostaTipoRadioButton.vue